import {
    cleanCommonParams,
    mapContentParams,
    mapImageParams,
    mapSalesChannelsParams,
    mapPlatformsParams,
    mapProductsParams,
    mapStatesParams,
} from './common';

const mapPagesParams = (_isCreate, pages) => {
    if (!pages || !Array.isArray(pages) || pages.length === 0) return [];

    return {
        pages,
    };
};

const mapHomeBannerParams = (
    isCreate,
    {
        content,
        image,
        sales_channels,
        platforms,
        products,
        states,
        pages,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            home_banner: {
                ...cleanCommonParams(params),
                ...mapContentParams(isCreate, content),
                ...mapImageParams(isCreate, image),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapStatesParams(isCreate, states),
                ...mapPagesParams(isCreate, pages),
            },
        });
    });
};

export { mapHomeBannerParams };
